import { forwardRef } from 'react';
import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    return (
        <SvgIcon ref={ref} {...props}>
            <path
                d='M3 3H4M4 3H20M4 3V15H10M21 3H20M20 3V15H14M14 15H10M14 15L16 21M10 15L8 21'
                stroke='currentColor'
                strokeWidth='2'
                strokeLinecap='round'
                strokeLinejoin='round'
                fill='none'
            />
        </SvgIcon>
    );
});
